import React from "react";
//PrimeReact Components
import * as pr from "../../../common/PrimeComponents";
import * as format from "../../../common/FormatFunctions";
import { BPMStatistics } from "../../Common/BPMChart";
import { DisplayType } from "../../Common/Statistics/ChartObjects";
import { ChartType } from "../../Common/Statistics/ChartObjects";
import { ViewState } from "../../../common/config/AppConstants";
import * as ChartHelper from "../../Statistics/ChartExamples";

export class AnalyticsCard extends React.Component {
  state = {
    dropVal: "This Year",
    dropOptions: [
      { label: "All Dates", value: "All Dates" },
      { label: "Today", value: "Today" },
      { label: "This Week", value: "This Week" },
      { label: "This Month", value: "This Month" },
      { label: "This Quarter", value: "This Quarter" },
      { label: "This Year", value: "This Year" }
    ],
    calVal1: "",
    calVal2: ""
  };

  render() {
    const { selectedReport } = this.props;

    return (
      <React.Fragment>
        <div className="ui-g-12">
          <pr.Button
            type="button"
            icon="pi pi-arrow-left"
            className="p-button-success"
            onClick={f => this.props.updateState("showCard", false)}
            style={{ marginRight: ".25em", float: "left" }}
          ></pr.Button>

          <div className="ui-g-12 card">
            <div className="ui-g-12">
              <h1>{selectedReport + " Report"}</h1>
            </div>
            <div className="ui-g-12">
              <label>Report peroid</label>
            </div>
            <div className="ui-g-12">
              <div className="ui-g-12 ui-lg-2">
                <pr.Dropdown
                  value={this.state.dropVal}
                  options={this.state.dropOptions}
                  onChange={e => {
                    this.setState({ dropVal: e.value });
                  }}
                />
              </div>
              <div className="ui-g-12 ui-lg-2">
                <pr.Calendar
                  value={this.state.calVal1}
                  onChange={e => {
                    this.setState({ calVal1: e.value });
                  }}
                  dateFormat="dd/mm/yy"
                  showIcon={true}
                />
              </div>
              <div className="ui-g-12 ui-lg-1">
                <center>
                  <label>to</label>
                </center>
              </div>
              <div className="ui-g-12 ui-lg-2">
                <pr.Calendar
                  value={this.state.calVal2}
                  onChange={e => {
                    this.setState({ calVal2: e.value });
                  }}
                  dateFormat="dd/mm/yy"
                  showIcon={true}
                />
              </div>
            </div>
            <div className="ui-g-12">
              <label>Compare To</label>
            </div>
            <div className="ui-g-12">
              <div className="ui-g-12 ui-lg-2">
                <pr.Dropdown
                  value={this.state.compareDropVal}
                  options={this.state.dropOptions}
                  onChange={e => {
                    this.setState({ compareDropVal: e.value });
                  }}
                />
              </div>
              <div className="ui-g-12 ui-lg-2">
                <pr.Dropdown
                  placeholder={"Select Product"}
                  value={this.state.productSelected}
                  options={[{ label: "All Products", value: "All Products" }]}
                  onChange={e => {
                    this.setState({ productSelected: e.value });
                  }}
                />
              </div>
              <div className="ui-g-12 ui-lg-2">
                <pr.Button label={"Generate Report"} onChange={e => {}} />
              </div>
              <div className="ui-g-12">{this.getChartRequired()}</div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  getChartRequired = () => {
    var data = null;
    var x = "";
    var y = "";
    if (this.props.selectedReport === "Lead Time") {
      console.log("Lead Time");
      data = this.renderLeadTime();
      x = "Product";
      y = "Time(Days)";
    }
    if (this.props.selectedReport === "Manufacturing Cycle Time") {
      console.log("Lead Time");
      data = this.renderManufacturingTime();
      x = "Product";
      y = "Time(Days)";
    }
    if (this.props.selectedReport === "Station/Process Cycle Time") {
      console.log("Lead Time");
      data = this.renderStationTime();
      x = "Station";
      y = "Time(Mins)";
    }
    if (this.props.selectedReport === "Queue Time") {
      console.log("Lead Time");
      data = this.renderQueueTime();
      x = "Station";
      y = "Time(Mins)";
    }
    if (!format.isNotNull(data)) {
      return <React.Fragment></React.Fragment>;
    } else {
      return (
        <React.Fragment>
          {this.getChart(
            DisplayType.CHART,
            ChartType.BAR,
            data,
            this.renderBarOptions(x, y)
          )}
        </React.Fragment>
      );
    }
  };
  getChart = (displayType, chartType, chartData, chartOptions) => {
    return (
      <BPMStatistics
        displayType={displayType}
        chartType={chartType}
        chartData={chartData}
        chartOptions={chartOptions}
      />
    );
  };

  renderBarOptions = (x, y) => {
    var chartOptionBean = {};

    chartOptionBean.chartArea = {
      bottom: null,
      left: null,
      top: null,
      right: null,
      width: "75%",
      height: "75%"
    };
    chartOptionBean.title = "";
    chartOptionBean.hAxis = { title: x, minValue: 0 };
    chartOptionBean.vAxis = { title: y, minValue: 0 };

    //Optional

    chartOptionBean.colors = ["#00ff00", "#ffab91"];

    return chartOptionBean;
  };
  renderLeadTime = () => {
    var chartDataBean = {};

    chartDataBean.rows = [];
    chartDataBean.columns = [];

    chartDataBean.columns = [
      { label: "Product", type: "string", id: null },
      { label: "Actual Lead Time (Days)", type: "number", id: null },
      { label: "Target Lead Time (Days)", type: "number", id: null }
    ];

    //(["Product Name", Actual, Target])

    //
    chartDataBean.rows.push(["True Grit", 21, 30]);
    chartDataBean.rows.push(["5x3 Full Sided Trailer", 30, 21]);
    chartDataBean.rows.push(["Bale Trailer", 49, 30]);
    chartDataBean.rows.push(["Precision Spreader", 15, 30]);
    chartDataBean.rows.push(["Forager", 60, 55]);

    console.log(chartDataBean.rows);

    return chartDataBean;
  };
  renderManufacturingTime = () => {
    var chartDataBean = {};

    chartDataBean.rows = [];
    chartDataBean.columns = [];

    chartDataBean.columns = [
      { label: "Product", type: "string", id: null },
      { label: "Average Manufacturing Time (Days)", type: "number", id: null },
      { label: "Target Manufacturing Time (Days)", type: "number", id: null }
    ];

    //(["Product Name", Actual, Target])

    //
    chartDataBean.rows.push(["True Grit", 21, 30]);
    chartDataBean.rows.push(["5x3 Full Sided Trailer", 30, 21]);
    chartDataBean.rows.push(["Bale Trailer", 49, 30]);
    chartDataBean.rows.push(["Precision Spreader", 15, 30]);
    chartDataBean.rows.push(["Forager", 60, 55]);

    console.log(chartDataBean.rows);

    return chartDataBean;
  };
  renderStationTime = () => {
    var chartDataBean = {};

    chartDataBean.rows = [];
    chartDataBean.columns = [];

    chartDataBean.columns = [
      { label: "Station", type: "string", id: null },
      { label: "Average Cycle Time (Mins)", type: "number", id: null },
      { label: "Target Cycle Time (Mins)", type: "number", id: null }
    ];

    //(["Product Name", Actual, Target])

    //
    chartDataBean.rows.push(["Laser", 21, 30]);
    chartDataBean.rows.push(["Folding", 30, 21]);
    chartDataBean.rows.push(["Section Cutting", 49, 30]);
    chartDataBean.rows.push(["Drilling", 15, 30]);
    chartDataBean.rows.push(["Plate Rolling", 60, 55]);
    chartDataBean.rows.push(["Turning", 60, 55]);

    console.log(chartDataBean.rows);

    return chartDataBean;
  };
  renderQueueTime = () => {
    var chartDataBean = {};

    chartDataBean.rows = [];
    chartDataBean.columns = [];

    chartDataBean.columns = [
      { label: "Station", type: "string", id: null },
      { label: "Average Queue Time (Mins)", type: "number", id: null },
      { label: "Target Queue Time (Mins)", type: "number", id: null }
    ];

    //(["Product Name", Actual, Target])

    //
    chartDataBean.rows.push(["Laser", 15, 25]);
    chartDataBean.rows.push(["Folding", 19, 20]);
    chartDataBean.rows.push(["Section Cutting", 30, 20]);
    chartDataBean.rows.push(["Drilling", 9, 18]);
    chartDataBean.rows.push(["Plate Rolling", 47, 50]);
    chartDataBean.rows.push(["Turning", 45, 35]);

    console.log(chartDataBean.rows);

    return chartDataBean;
  };
}



// WEBPACK FOOTER //
// ./src/components/Analytics/UI/AnalyticsCard.js